import React, { useState, useEffect } from 'react';
import { bookings } from '../../api';
import SlotCourtInfo from './SlotCourtInfo';
import './SlotHighlightsBanner.css';

/**
 * Banner at the top of a student's Coaching tab: this week's open slots from
 * their coach(es) that the coach has featured (⭐) or that start within 48h
 * ("Last minute"). Each slot shows start time, duration, location and court.
 * Renders nothing when there is nothing to show.
 *
 * onPick(slot) - student tapped a slot: the parent opens it for booking.
 */
const dayLabel = (d) => new Date(d).toLocaleDateString('en-US', { weekday: 'short', day: 'numeric', month: 'short' });
const timeLabel = (d) => new Date(d).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
const minutes = (s) => Math.round((new Date(s.endTime) - new Date(s.startTime)) / 60000);

export default function SlotHighlightsBanner({ onPick, refreshKey = 0 }) {
  const [coaches, setCoaches] = useState([]);

  useEffect(() => {
    let cancelled = false;
    bookings.getMyCoachHighlights()
      .then(res => { if (!cancelled) setCoaches(res.data.coaches || []); })
      .catch(() => { if (!cancelled) setCoaches([]); });
    return () => { cancelled = true; };
  }, [refreshKey]);

  if (coaches.length === 0) return null;

  return (
    <div className="slot-highlights">
      {coaches.map(c => (
        <div key={c.coachId} className="slot-highlights__card">
          <div className="slot-highlights__head">
            <span className="slot-highlights__megaphone">📣</span>
            <div>
              <div className="slot-highlights__title">
                {c.coachName} has {c.slots.length} open slot{c.slots.length !== 1 ? 's' : ''}
              </div>
              {c.message && <div className="slot-highlights__message">“{c.message}”</div>}
            </div>
          </div>

          <div className="slot-highlights__list">
            {c.slots.map(s => (
              <button
                type="button"
                key={s._id}
                className="slot-highlights__slot"
                onClick={() => onPick && onPick(s)}
              >
                <div className="slot-highlights__when">
                  <span className="slot-highlights__day">{dayLabel(s.startTime)}</span>
                  <span className="slot-highlights__time">{timeLabel(s.startTime)}</span>
                  <span className="slot-highlights__dur">{minutes(s)} min</span>
                  <span className="slot-highlights__tags">
                    {s.lastMinute && <span className="slot-highlights__tag slot-highlights__tag--hot">Last minute</span>}
                    {s.featured && <span className="slot-highlights__tag slot-highlights__tag--snatch">Snatch it!</span>}
                  </span>
                </div>
                <SlotCourtInfo slot={s} margin="4px 0 0" />
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
